import React from 'react'
import PropTypes from 'prop-types'

import { Layout } from 'antd';

export const PageLayout = ({ children }) => (
  <Layout style={{ minHeight: '100vh' }}>
    {children}
  </Layout>
)

PageLayout.propTypes = {
  children: PropTypes.node,
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/layouts/GeneralLayout/index.js